import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/logo/alba.png'


const _hoisted_1 = { class: "auth-wrapper-inner columns is-gapless" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"column login-column is-9 h-hidden-mobile h-hidden-tablet-p hero-banner\"><div id=\"friAuthBack\" class=\"hero login-hero is-fullheight is-app-grey\"><div class=\"hero-body\"><div class=\"columns\"><div class=\"column text-white is-12 is-offset-1\"><h2 style=\"font-size:60px;\" class=\"fw-bold\">ALBA</h2><h2 style=\"font-size:40px;\">Artificial logic-based advisor</h2><h2 style=\"font-size:20px;\">La revolución en el control de cámaras frigoríficas</h2></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "column is-3" }
const _hoisted_4 = { class: "hero is-fullheight" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hero-heading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "auth-logo mt-5" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_6 = {
  class: "hero-body mt-0 pt-0",
  style: {"scrollbar-width":"none !important"}
}
const _hoisted_7 = { class: "container p-0" }
const _hoisted_8 = { class: "columns ms-2" }
const _hoisted_9 = {
  key: 0,
  class: "column is-12"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "auth-content text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Recuperar contraseña"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, "Introduzca su dirección de correo electrónico y le enviaremos las instrucciones para restablecer su contraseña.")
], -1)
const _hoisted_11 = { class: "auth-form-wrapper" }
const _hoisted_12 = { class: "recovery-form" }
const _hoisted_13 = { class: "text-center mt-5" }
const _hoisted_14 = { class: "mt-5 text-center" }
const _hoisted_15 = {
  key: 1,
  class: "column is-12 mt-0 pt-0"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "auth-content text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fs-2" }, "Iniciar sesión")
], -1)
const _hoisted_17 = { class: "auth-form-wrapper" }
const _hoisted_18 = { id: "friAuthBox" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "login-form" }
const _hoisted_21 = { class: "forgot-link has-text-centered mt-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-5",
  style: {"padding-top":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-xs3" }, [
    /*#__PURE__*/_createTextVNode(" © 2024 Fricontrol sistemas de refrigeración, S.L. "),
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.layout.recovery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("form", _hoisted_12, [
                        _createVNode(_component_ion_item, { lines: "full" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Email")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "email",
                              modelValue: _ctx.layout.recoveryEmail,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.layout.recoveryEmail) = $event)),
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("a", {
                            class: "friBtn1 text-white",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recoveryPass()))
                          }, "Enviar")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ion_label, {
                          class: "cursor-pointer friColor1",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.layout.recovery = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Volver al inicio de sesión")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.login)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("form", _hoisted_20, [
                                _createVNode(_component_ion_item, { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Correo electrónico")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.email,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                                      type: "text",
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Contraseña")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.password,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                                      type: "password",
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  onClick: _ctx.doLogin,
                                  class: "loginBtn"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Iniciar sesión")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("a", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.layout.recovery = true)),
                            class: "fs-6 friColor1"
                          }, "¿Olvidó su contraseña?")
                        ]),
                        _hoisted_22
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}